/**
 * @TODO
 * Need to be done the task type DB table on BE and add Admin UI to manage task types
 */
export const taskTypes = [
    { id: "task", label: "Task" },
    { id: "summary", label: "Summary task" },
    { id: "milestone", label: "Milestone" },
    { id: "urgent", label: "Urgent" },
    { id: "narrow", label: "Narrow" },
    { id: "progress", label: "Progress" },
    { id: "round", label: "Rounded" },
    { id: "consultant", label: "Berater" },
    { id: "message", label: "Message" },
];
